import { RouteConfig } from 'vue-router'
const MagicStoreIndex = () => import('../activity/sfruit-magic-store/Index.vue')

export const MagicStoreIndexRoute: RouteConfig = {
  path: '/activity/sfruit-magic-store',
  name: 'activity_sfruit_magic_store',
  component: MagicStoreIndex,
  meta: {
    title: '魔法果汁店',
  },
  props: (route) => ({ ...route.query }),
}

export default [MagicStoreIndexRoute]
